import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

import API from "../../../network";

import closeIcon from "src/Assets/images/Add.png";

import moderatorBlogStyles from "src/Assets/css/Moderator/ModeratorBlog.module.css";

import {
  capitalizeFirstLetter,
  ignoreSpacesAndUrlsFromMsg,
} from "src/Utils/commonUtils";

const NominateUser = ({
  result,
  children,
  contributor = false,
  disabled = false,
  onModalOpen,
  onModalClose,
  onActionSuccess,
}) => {
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const [showImpactfulMemberPopup, setShowImpactfulMemberPopup] =
    useState(false);

  const [impactfulMemberText, setImpactfulMemberText] = useState("");

  const [impactfulMemberCharCount, setImpactfulMemberCharCount] = useState(0);

  const [isPostingImpactfulMember, setIsPostingImpactfulMember] =
    useState(false);
    
   const userId = contributor
        ? result?.id
        : result?.userid || result?.mainuserdata?.userid;

  const onImpactfulMemberTextChange = (e) => {
    const textValue = e.target.value;

    const { msgLength } = ignoreSpacesAndUrlsFromMsg(textValue);

    const formattedValue = capitalizeFirstLetter(textValue);

    setImpactfulMemberCharCount(msgLength);
    setImpactfulMemberText(formattedValue);
  };

  const handleCloseModal = () => {
    setShowImpactfulMemberPopup(false);
    onModalClose?.();
  };

  const postImpactfulMember = async () => {
    try {
      if (!impactfulMemberText.trim() || impactfulMemberCharCount > 280) {
        return;
      }

      setIsPostingImpactfulMember(true);

      const tenantID =
        result?.tenantID || result?.Tenant_ID || result?.mainuserdata?.tenantID;
      const userId = contributor
        ? result?.id
        : result?.userid || result?.mainuserdata?.userid;
      const formData = new FormData();

      formData.append("userid", userId);

      formData.append("tenantid", tenantID);

      formData.append("description", impactfulMemberText.trim());

      formData.append("dispayname", result?.mainuserdata?.displayName || result?.displayName);

      const response = await API.nominateUser(formData);

      const statusMessage =
        response?.data?.formstatus || response?.data?.status;

      if (!statusMessage) {
        return;
      }

      alert(statusMessage);

      if (
        statusMessage.toLowerCase().includes("submitted") ||
        statusMessage.toLowerCase().includes("nominated")
      ) {
        handleCloseModal();
        setImpactfulMemberText("");
        setImpactfulMemberCharCount(0);
        if (response?.data?.justFollowed) {
          onActionSuccess?.();
        }
      }
    } catch (error) {
      console.error("Error nominating impactful member:", error);
    } finally {
      setIsPostingImpactfulMember(false);
    }
  };

  const onNominateUser = async (e) => {
    if (disabled) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      return;
    }

    try {
      if (result?.mainuserdata?.isImpactableMember === "yes" || result?.isImpactableMember === "yes") {
        alert(
          `${result?.mainuserdata?.displayName || result?.displayName} is already an Impactful Member.`,
        );
        return;
      }

      const tenantID =
        result?.tenantID || result?.Tenant_ID || result?.mainuserdata?.tenantID;
      const userId = contributor
        ? result?.id
        : result?.userid || result?.mainuserdata?.userid;

      const response = await API.checkNominationStatus(tenantID, userId);

      if (response?.data?.isAlreadyNominated === 1) {
        alert("You already nominated.");
        return;
      }

      setShowImpactfulMemberPopup(true);
      onModalOpen?.();
    } catch (error) {
      console.error("Error checking nomination status:", error);
    }
  };

  if (userId === userDetails?.userData?.User_ID) {
    return null;
  }

  return (
    <>
      <div
        onClick={onNominateUser}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          display: "inline-flex",
          alignItems: "center",
        }}
        title={disabled ? "Follow community to nominate" : undefined}
      >
        {children}
      </div>

      <Modal
        open={showImpactfulMemberPopup}
        onClose={handleCloseModal}
        onMouseEnter={(e) => e.stopPropagation()}
        onMouseLeave={(e) => e.stopPropagation()}
        onMouseOver={(e) => e.stopPropagation()}
        onMouseOut={(e) => e.stopPropagation()}
        sx={{ zIndex: 10001 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "#fff",
            borderRadius: "20px",
            padding: "16px 16px 5px 16px",
            width: "90%",
            maxWidth: "600px",
            outline: "none",
            boxShadow: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
              padding: "0 30px",
            }}
          >
            <h4 style={{ margin: 0 }}>Impactful Member</h4>

            <img
              src={closeIcon}
              alt="Close"
              onClick={handleCloseModal}
              style={{
                width: 18,
                height: 18,
                cursor: "pointer",
              }}
            />
          </div>

          <div className={moderatorBlogStyles.blogPostContainer}>
            <div className={moderatorBlogStyles.textAreaContainer}>
              <textarea
                className={moderatorBlogStyles.impactfulMemberModalTextArea}
                placeholder={`Why would you like to nominate ${result?.mainuserdata?.displayName || result?.displayName || "this user"} as an Impactful Member?`}
                value={impactfulMemberText}
                onChange={onImpactfulMemberTextChange}
              />

              <div className={moderatorBlogStyles.charCountContainer}>
                <label
                  style={{
                    color: impactfulMemberCharCount > 280 ? "red" : "#666",
                  }}
                >
                  {impactfulMemberCharCount}
                </label>

                <label>/280</label>
              </div>
            </div>

            <div className={moderatorBlogStyles.buttonContainer}>
              <button
                className={moderatorBlogStyles.postButton}
                disabled={
                  !impactfulMemberText.trim() ||
                  impactfulMemberCharCount > 280 ||
                  isPostingImpactfulMember
                }
                onClick={postImpactfulMember}
              >
                {isPostingImpactfulMember ? "Sending..." : "Send"}
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default NominateUser;
